<template>
  <div class="page" id="create-project-step-4">
    <!-- <div class="decorative-texture top top-fade">
      <img src="../../assets/img/texture.png" />
    </div>-->
    <div class="container">
      <div class="page-navigation">
        <div class="row align-items-center">
          <div class="col-auto">
            <button class="button back-button" @click="() => {back(); }">
              <svg width="10.975" height="9.998" viewBox="0 0 10.975 9.998">
                <path
                  id="Color_Overlay"
                  data-name="Color Overlay"
                  d="M26.825,57.835l-3.549-4.046A.634.634,0,0,1,23,53.244v-.366a.7.7,0,0,1,.068-.308.641.641,0,0,1,.14-.282l3.615-4.122a.439.439,0,0,1,.706.028l.205.267a.706.706,0,0,1-.023.861L25.13,52.268h8.343a.564.564,0,0,1,.5.609v.366a.564.564,0,0,1-.5.609H25.236l2.478,2.825a.708.708,0,0,1,.023.861l-.205.266a.462.462,0,0,1-.365.194A.455.455,0,0,1,26.825,57.835Z"
                  transform="translate(-23 -48.001)"
                />
              </svg>
            </button>
          </div>
          <div class="col">
            <div>
              <h1 class="page-title">INDICADORES</h1>
            </div>
          </div>
          <div class="col-1"></div>
        </div>
      </div>
    </div>
    <section>
      <div class="container">
        <!-- <h1 class="section-title">Pasos</h1> -->
        <div class="steps">
          <div class="step">
            <span>01</span>
          </div>
          <div class="step">
            <span>02</span>
          </div>
          <div class="step acrive">
            <span>03</span>
          </div>
        </div>
        <div class="input-field">
          <label class="form-text">Nombre</label>
          <input type="text" placeholder="ej. Indicador de redes sociales" v-model="nGauge" />
        </div>

        <div class="card head-card">
          <div class="title-card">
            <h4>Tipo de indicador</h4>
          </div>
          <div class="card-content">
            <div class="checkbox iconed">
              <label for="check1">
                <span class="btn-icon">
                  <svg
                    version="1.1"
                    id="icons"
                    x="0px"
                    y="0px"
                    viewBox="0 0 28 28"
                    style="enable-background:new 0 0 28 28;"
                    xml:space="preserve"
                  >
                    <g>
                      <g>
                        <path
                          d="M28,26.782608H0.6086956C0.2722487,26.782608,0,26.5103607,0,26.173914V1.2173913h1.2173913v24.347826H28V26.782608z"
                        />
                      </g>
                      <g>
                        <rect x="3.652174" y="24.347826" width="1.2173913" height="1.826087" />
                      </g>
                      <g>
                        <rect x="7.304348" y="24.347826" width="1.2173913" height="1.826087" />
                      </g>
                      <g>
                        <rect x="10.956522" y="24.347826" width="1.2173913" height="1.826087" />
                      </g>
                      <g>
                        <rect x="14.608696" y="24.347826" width="1.2173913" height="1.826087" />
                      </g>
                      <g>
                        <rect x="18.26087" y="24.347826" width="1.2173913" height="1.826087" />
                      </g>
                      <g>
                        <rect x="21.913044" y="24.347826" width="1.2173913" height="1.826087" />
                      </g>
                      <g>
                        <rect x="25.565218" y="24.347826" width="1.2173913" height="1.826087" />
                      </g>
                      <g>
                        <rect x="0.6086956" y="21.913044" width="1.826087" height="1.2173913" />
                      </g>
                      <g>
                        <rect x="0.6086956" y="18.26087" width="1.826087" height="1.2173913" />
                      </g>
                      <g>
                        <rect x="0.6086956" y="14.608696" width="1.826087" height="1.2173913" />
                      </g>
                      <g>
                        <rect x="0.6086956" y="10.956522" width="1.826087" height="1.2173913" />
                      </g>
                      <g>
                        <rect x="0.6086956" y="7.304348" width="1.826087" height="1.2173913" />
                      </g>
                      <g>
                        <rect x="0.6086956" y="3.652174" width="1.826087" height="1.2173913" />
                      </g>
                      <g>
                        <path
                          d="M4.869565,12.173913H3.652174v-1.217391h0.924932l2.2516985-2.815218
                                                C6.9447179,7.9968581,7.1194801,7.9130435,7.304348,7.9130435h2.1090355l1.036684-1.555027
                                                c0.1129417-0.1694126,0.3031597-0.27106,0.5064545-0.27106h2.434782c0.2181559,0,0.4202623,0.1171026,0.5284481,0.3067255
                                                l2.2594261,3.954144h1.7892323l2.2516975-2.8152175c0.1159153-0.1444464,0.2906761-0.2282605,0.475544-0.2282605h1.217392
                                                c0.161684,0,0.3162365,0.064198,0.4303665,0.1783285L23.991169,9.130435h3.400135v1.217391H23.73913
                                                c-0.161684,0-0.3162365-0.0641985-0.4303665-0.1783285L21.661005,8.521739h-0.6728935l-2.2516975,2.815218
                                                c-0.1159153,0.1444454-0.2906761,0.22826-0.475544,0.22826h-2.434783c-0.2181559,0-0.4202614-0.1171026-0.5284481-0.3067255
                                                L13.0382137,7.304348h-1.7559443l-1.036685,1.555027c-0.1129417,0.1694126-0.3031588,0.27106-0.5064545,0.27106H7.596807
                                                l-2.2516985,2.815217C5.2291951,12.0900984,5.0544329,12.173913,4.869565,12.173913z"
                        />
                      </g>
                      <g>
                        <path
                          d="M6.695652,20.695652H3.652174V19.47826h2.751019l2.251698-2.8152161
                                                c0.1159143-0.1444473,0.2906761-0.2282619,0.475544-0.2282619h3.652174c0.1914063,0,0.3721123,0.090353,0.4868374,0.2437172
                                                l1.6435966,2.1910667h3.095788l4.6912365-4.6912374C22.8141975,14.0641985,22.96875,14,23.130434,14h4.26087v1.217391h-4.008831
                                                l-4.6912365,4.6912374c-0.11413,0.11413-0.2686825,0.1783276-0.4303665,0.1783276h-3.652174
                                                c-0.1914063,0-0.3721132-0.090353-0.4868383-0.2437153L12.478261,17.652174H9.4228945l-2.251699,2.815218
                                                C7.0552821,20.6118374,6.8805199,20.695652,6.695652,20.695652z"
                        />
                      </g>
                    </g>
                  </svg>
                </span>
                <input
                  class="box"
                  type="checkbox"
                  id="check1"
                  value
                  :checked="graficas[0].estatus"
                  @click="() => {slect(0);}"
                />
                Gráfico de barra
                <span class="nbox">
                  <svg viewBox="0 0 14.018 13.003">
                    <path
                      id="Rectángulo_9"
                      data-name="Rectángulo 9"
                      d="M304.98,386.9s1.489,1.413,3.5,3.546c4.553-2.794,10.514-9.457,10.514-9.457l-10.514,13Z"
                      transform="translate(-304.98 -380.994)"
                      fill="#fff"
                    />
                  </svg>
                </span>
              </label>
            </div>
            <div class="checkbox iconed">
              <label for="check2">
                <span class="btn-icon">
                  <svg
                    version="1.1"
                    id="icons"
                    x="0px"
                    y="0px"
                    viewBox="0 0 28 28"
                    style="enable-background:new 0 0 28 28;"
                    xml:space="preserve"
                  >
                    <g>
                      <g>
                        <path
                          d="M17.6583881,9.3271189c-0.126152,0-0.2523022-0.0372858-0.3619862-0.113101
                                                    c-0.345829-0.2386312-0.7245922-0.442462-1.1254177-0.6046562c-0.2703247-0.1087513-0.4318981-0.3877754-0.3921261-0.676743
                                                    l0.9588737-6.9377012c0.0248585-0.1802162,0.1255302-0.3411679,0.2765388-0.4418404s0.3374386-0.1323657,0.5139275-0.0870009
                                                    c2.092371,0.5437557,4.05797,1.5846593,5.6839561,3.0096099c0.1357822,0.1186941,0.2143936,0.2902102,0.2168808,0.4704263
                                                    c0.0021744,0.1802163-0.0720882,0.3535967-0.2047634,0.4760194l-5.1342964,4.7365785
                                                    C17.9687958,9.2699471,17.8140583,9.3271189,17.6583881,9.3271189z M17.1049995,7.6330872
                                                    c0.1646805,0.0801649,0.3253212,0.1665444,0.4816132,0.2578955l4.2394295-3.910691
                                                    c-1.1735802-0.9166167-2.511219-1.6250527-3.9284019-2.0818076L17.1049995,7.6330872z"
                        />
                      </g>
                      <g>
                        <path
                          d="M21.5324154,25.6721039c-0.0506477,0-0.1016064-0.0062141-0.1519413-0.0186424
                                                    c-0.1758671-0.0428791-0.3246994-0.1590881-0.4098377-0.3187962l-3.2908077-6.1845226
                                                    c-0.1388912-0.2610016-0.079855-0.5829048,0.1426182-0.7780361c1.2652416-1.1073971,1.9910774-2.700757,1.9910774-4.3717957
                                                    c0-0.9495525-0.2246475-1.8580914-0.6680412-2.700757c-0.1339207-0.2554102-0.079855-0.5686131,0.1317444-0.7643652
                                                    l5.159153-4.7595711C24.57061,5.6519518,24.7517586,5.59478,24.9329071,5.6103158
                                                    c0.1817703,0.0186429,0.3464508,0.1143441,0.4527149,0.262867C27.0958118,8.2650862,28,11.0752163,28,14.0003109
                                                    c0,4.623476-2.2834625,8.9449368-6.1083965,11.5605564C21.7847176,25.6341972,21.6594982,25.6721039,21.5324154,25.6721039z
                                                    M19.0317593,18.9811134l2.7190895,5.1100597c3.1289253-2.404953,4.9764519-6.1261063,4.9764519-10.0908623
                                                    c0-2.4173822-0.6798496-4.7483854-1.972435-6.7866926l-4.2686367,3.9380341
                                                    c0.3936787,0.8961096,0.5999947,1.8711414,0.5999947,2.8486586
                                                    C21.0862236,15.8683443,20.3429871,17.6568356,19.0317593,18.9811134z"
                        />
                      </g>
                      <g>
                        <path
                          d="M10.3450298,9.3246336c-0.1556692,0-0.3107176-0.0571728-0.4318972-0.1690311L4.7816319,4.4152961
                                                    c-0.1323652-0.1224227-0.2069378-0.2951818-0.204452-0.4760191c0.0024858-0.1802161,0.081408-0.3511109,0.2171917-0.4704263
                                                    C7.3512664,1.2323058,10.620636,0,14,0c0.0711546,0,0.1413765,0.00435,0.2112875,0.0093215l0.1084404,0.0062144
                                                    c0.1817703,0.0031072,0.3535967,0.0845152,0.4719801,0.2224738c0.1183834,0.13858,0.1718273,0.3206605,0.1469698,0.5008767
                                                    l-0.957942,6.9308653c-0.0403938,0.2914529-0.2746744,0.5170341-0.5670595,0.5462413
                                                    c-0.9669533,0.0969439-1.9031448,0.4412193-2.7072821,0.9961605C10.5970211,9.2873468,10.47087,9.3246336,10.3450298,9.3246336z
                                                    M6.1798611,3.9740772l4.2369442,3.9144197c0.7314291-0.4294119,1.5361872-0.725215,2.3692217-0.8700089l0.7929506-5.7389531
                                                    C10.893446,1.3690214,8.3039265,2.3142242,6.1798611,3.9740772z"
                        />
                      </g>
                      <g>
                        <path
                          d="M14,28C6.2802229,28,0,21.7197781,0,13.9996891c0-2.9282017,0.9060524-5.7414389,2.6199703-8.1339636
                                                    c0.1062653-0.1485229,0.2712564-0.2442241,0.4527154-0.262867c0.1792841-0.0174003,0.3619859,0.041636,0.4965267,0.1659231
                                                    l5.1557355,4.7626781c0.2115993,0.1957521,0.2653532,0.508956,0.1311235,0.7637444
                                                    c-0.4446373,0.8439083-0.6699076,1.7536898-0.6699076,2.7044849c0,3.2059841,2.6081629,5.814146,5.8138361,5.814146
                                                    c0.4368687,0,0.8905163-0.0553074,1.3488245-0.1640587c0.2818213-0.0671139,0.5732746,0.0646305,0.7090578,0.3200397
                                                    l3.2957802,6.1944637c0.0854473,0.1609516,0.0981865,0.3504906,0.0344906,0.5213852
                                                    c-0.0636978,0.1708946-0.1976166,0.3057461-0.3675785,0.3716183C17.3958321,27.6824474,15.7067719,28,14,28z M3.2497947,7.206161
                                                    C1.9541026,9.2457113,1.272699,11.5791998,1.272699,13.9996891c0,7.0178661,5.709435,12.7276115,12.7273006,12.7276115
                                                    c1.3134031,0,2.6165524-0.2075596,3.8833485-0.6170845l-2.7259254-5.1231117
                                                    c-4.4211998,0.7457237-8.2439575-2.7007561-8.2439575-6.9874153c0-0.9793816,0.2069378-1.9562778,0.60186-2.8530083
                                                    L3.2497947,7.206161z"
                        />
                      </g>
                    </g>
                  </svg>
                </span>
                <input
                  class="box"
                  type="checkbox"
                  id="check2"
                  value
                  :checked="graficas[1].estatus"
                  @click="() => {slect(1);}"
                />
                Grafico de líneas
                <span class="nbox">
                  <svg viewBox="0 0 14.018 13.003">
                    <path
                      id="Rectángulo_9"
                      data-name="Rectángulo 9"
                      d="M304.98,386.9s1.489,1.413,3.5,3.546c4.553-2.794,10.514-9.457,10.514-9.457l-10.514,13Z"
                      transform="translate(-304.98 -380.994)"
                      fill="#fff"
                    />
                  </svg>
                </span>
              </label>
            </div>

            <div class="checkbox iconed">
              <label for="check8">
                <span class="btn-icon">
                  <svg
                    version="1.1"
                    id="icons"
                    x="0px"
                    y="0px"
                    viewBox="0 0 28 28"
                    style="enable-background:new 0 0 28 28;"
                    xml:space="preserve"
                  >
                    <g>
                      <g>
                        <path
                          d="M15.7530165,16.899147c-1.2911053,0-3.3265734-0.2927341-4.2702703-0.6145134l0.3758841-1.1037312
                                                c0.8181171,0.2784958,2.7468004,0.5518656,3.8943863,0.5518656c6.628087,0,11.0806036-3.3171759,11.0806036-6.4150867
                                                c0-3.2701907-4.8671284-5.8318968-11.0806036-5.8318968c-6.3464594,0-11.7079325,2.6508367-11.7079325,5.7883282
                                                c0,0.5248146,0.1298509,1.0470648,0.3858509,1.5522308l-1.0405154,0.5273762
                                                c-0.3394346-0.6703262-0.5117149-1.3699837-0.5117149-2.079607c0-3.899796,5.6550612-6.9547076,12.8743114-6.9547076
                                                C22.7347775,2.3194051,28,5.3279009,28,9.3176813C28,13.4273462,22.3913555,16.899147,15.7530165,16.899147z"
                        />
                      </g>
                      <g>
                        <path
                          d="M7.0051703,25.6805954l-0.6159372-0.0347404c-1.4314914-0.0803032-5.4318085-1.9608631-6.3581343-5.0818386
                                                c-0.0336017-0.1133347-0.0370189-0.1247253-0.0242047-8.3312407l0.0008543-0.469285l14.1830711-3.0833883l1.2358608,1.2364311
                                                l-8.4215107,7.8203802V25.6805954z M1.1709954,20.3037453c0.6882664,2.1619034,3.2770252,3.6193066,4.6677957,4.0481567
                                                v-7.1241398l7.7879181-7.2314959L1.1724192,12.7037697C1.1681478,15.6706905,1.1647307,19.7154293,1.1709954,20.3037453z"
                        />
                      </g>
                      <g>
                        <path
                          d="M15.7530165,25.0638027c-1.1797638,0-2.9549608-0.1890793-4.2617273-0.6116657l-0.4037905-0.1304188v-8.7894211
                                                l2.431571-3.623579l0.9687548,0.6498241l-2.2339468,3.3291359v7.5723534
                                                c1.006629,0.2659664,2.3532619,0.4373932,3.4991388,0.4373932c6.2134752,0,11.0806036-2.5617065,11.0806036-5.8318977V9.3176813
                                                H28v8.7478456C28,22.0550232,22.7347775,25.0638027,15.7530165,25.0638027z"
                        />
                      </g>
                      <g>
                        <path
                          d="M6.2536874,18.0404682c-3.4060216-1.0268459-5.737072-3.1557169-6.2359724-5.6943579L1.1624526,12.12115
                                                c0.4140419,2.1075125,2.4429612,3.9026442,5.4278216,4.8030558L6.2536874,18.0404682z"
                        />
                      </g>
                    </g>
                  </svg>
                </span>
                <input
                  class="box"
                  type="checkbox"
                  id="check8"
                  value
                  :checked="graficas[2].estatus"
                  @click="() => {slect(2);}"
                />
                Gráficas circulares
                <span class="nbox">
                  <svg viewBox="0 0 14.018 13.003">
                    <path
                      id="Rectángulo_9"
                      data-name="Rectángulo 9"
                      d="M304.98,386.9s1.489,1.413,3.5,3.546c4.553-2.794,10.514-9.457,10.514-9.457l-10.514,13Z"
                      transform="translate(-304.98 -380.994)"
                      fill="#fff"
                    />
                  </svg>
                </span>
              </label>
            </div>
          </div>
        </div>
        <button class="button fluid next-button" @click="() => {next();}">Siguiente</button>
      </div>
    </section>
    <div :class="['modal-container', modalStats ? 'active' : '']">
      <!--agregar clas "active" para mostrarlo  <div class="modal-container active">-->
      <div class="card head-card news modalCharts">
        <div class="title-card">
          <h4></h4>
          <button
            @click="
              () => {
                modalStats = false;
              }
            "
          >X</button>
        </div>
        <div class="card-content text-center">
          <h3>{{ texto }}</h3>
          <select v-model="xselected" @change="onChangeX($event)" class="selectX">
            <option value="tags" v-if="andQuery == false">Etiqueta</option>
            <option value="redes">Medio</option>
            <option value="canal">Programas</option>
            <!--  <option value="dias" v-if="tGrafica != '3'">Día</option>
            <option value="mes" v-if="tGrafica != '3'">Mes</option>-->
          </select>
          <button
            @click="() => {modalStats = false;}"
            class="button fluid alternative"
            :disabled="disabled"
          >OK</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
import axios from "axios";

import { dashMethods } from "@/services/dashServices.js";

export default {
  name: "step3",
  components: {},
  data: () => ({
    disabled: true,
    nGauge: "",
    tGrafica: "0",
    texto: "",
    modalStats: false,
    xselected: "",
    nProyecto: "",
    graficas: [
      { estatus: false, tipo: "1" },
      { estatus: false, tipo: "2" },
      { estatus: false, tipo: "3" },
      { estatus: false, tipo: "1" },
      { estatus: false, tipo: "1" },
      { estatus: false, tipo: "1" },
      { estatus: false, tipo: "1" },
      { estatus: false, tipo: "1" },
      { estatus: false, tipo: "1" },
      { estatus: false, tipo: "1" }
    ],
    grafica: -1,
    gaugeX: "",
    pKey: "",
    andQuery: false
  }),
  computed:{
    token(){
      return this.$store.getters.getToken;
    }
  },
  mixins: [dashMethods],

  methods: {
    onChangeX(event) {
      this.disabled = false;
      console.log(this.xselected);
      this.gaugeX = this.xselected;
    },
    slect(id) {
      let obj = this.graficas[id];
      this.graficas = [
        { estatus: false, tipo: "1" },
        { estatus: false, tipo: "2" },
        { estatus: false, tipo: "3" },
        { estatus: false, tipo: "1" },
        { estatus: false, tipo: "1" },
        { estatus: false, tipo: "1" },
        { estatus: false, tipo: "1" },
        { estatus: false, tipo: "1" },
        { estatus: false, tipo: "1" },
        { estatus: false, tipo: "1" }
      ];

      /*
if (this.graficas[id].estatus == true) {
this.graficas[id].estatus = false;
console.log(this.graficas[id].estatus);
}else{

this.graficas[id].estatus = true;
    console.log(this.graficas[id].estatus);
}*/

      if (this.graficas[id].tipo == "3") {
        this.texto = "Seleccione los valores para las etiquetas";
      } else {
        this.texto = "Seleccione los valores para el eje X";
      }

      if (obj.estatus == true) {
        obj.estatus = false;
        console.log("false");
        this.graficas[id].estatus = false;
        this.tGrafica = "0";
        this.grafica = -1;
      } else {
        obj.estatus = true;
        console.log("true");

        this.graficas[id].estatus = true;
        this.modalStats = true;
        this.tGrafica = this.graficas[id].tipo;
        this.grafica = id;
      }
    },
    cleanFiList(fi, param) {
      var list = {};
      Object.keys(fi).forEach(function(item) {
        if (fi[item].length > 0) {
          list[item] = fi[item];
        } else {
          if (param[item][0] == 1 && param[item][1] == 1) {
            list[item] = [];
          }
        }
      });

      return list;
    },
    cleanParams(param) {
      var list = {};
      Object.keys(param).forEach(function(item) {
        if (param[item].length > 0) {
          list[item] = param[item];
        }
      });

      return list;
    },
    saveGauge(key) {
      var that = this;
      var cleanList = this.cleanFiList(
        this.$store.state.projectConfig.fiList,
        this.$store.state.projectConfig.fiParams
      );
      var cleanParam = this.cleanParams(
        this.$store.state.projectConfig.fiParams
      );
      var dat = JSON.stringify({
        dashboardKey: key,
        gaugeQuery: {
          fi: cleanList,
          fiParams: cleanParam,
          ubicacion: "global",
          fecha: this.$store.state.projectConfig.fecha,
          hora: this.$store.state.projectConfig.hora,
          keywords: this.$store.state.projectConfig.keywords,
          dias: this.$store.state.projectConfig.nDias
        },
        gaugeConfig: {
          gaugetype: this.tGrafica,
          gaugeName: this.nGauge
        },
        andQuery: this.$store.state.projectConfig.andQuery,
        gaugeX: this.gaugeX
      });
      axios
        .post(
          that.url + "createGauge",
          dat
        )
        .then(async function(response) {
          console.log(response);
          if (response.data.success == true) {
            const addPanel = await that.addGaugePanel(
              response.data.data.key,
              key
            );
            that.$router.push({
              path: "/proyecto/" + that.$store.state.projectConfig.dashKey
            });
          }
        })
        .catch(function(error) {
          console.log("Error");
          console.log(error);
        });
    },
    saveNewProject() {
      var that = this;
      var dat = JSON.stringify({
        token: this.token,
        providerID: this.$store.state.userInfo.net,
        data: {
          nombre: this.$store.state.projectConfig.nProyecto,
          dashConfig: []
        }
      });
      axios
        .post(
          that.url + "createDashboard",
          dat
        )
        .then(function(response) {
          console.log(response);
          if (response.data.success == true) {
            that.saveGauge(response.data.data.key);
          }
        })
        .catch(function(error) {
          console.log("Error");
          console.log(error);
        });
    },
    next() {
      console.log(this.grafica);
      if (this.nGauge == "") {
        alert("Ingrese el nombre del indicador");
      } else {
        if (this.grafica >= 0) {
          this.$store.commit("addGrafica", this.grafica);

          if (this.$store.state.projectConfig.dashKey != "") {
            this.saveGauge(this.$store.state.projectConfig.dashKey);
          } else {
            this.$router.push({ path: "/busqueda/nueva/step4" });
          }

          //this.saveNewProject();
        } else {
          alert("Seleccione una gráfica");
        }
      }
    },
    back() {
      this.$router.push({ path: "/busqueda/nueva/step2" });
    }
  },
  beforeMount() {
    console.log("BeforeStep3");
    this.andQuery = this.$store.state.projectConfig.andQuery;
    if (this.$store.state.projectConfig.grafica != null) {
      this.graficas[this.$store.state.projectConfig.grafica].estatus = true;
    }
  }
};
</script>

<style lang="scss">
.fil1 {
  fill: #fefefe;
  fill-rule: nonzero;
}
.fil0 {
  fill: #00b99e;
  fill-rule: nonzero;
}
.text-center {
  text-align: center;
}

.modalCharts {
  margin-top: 13vh !important;
}

.selectX {
  margin: 10px 0px 20px;
  font-size: 1.2em;
  min-width: 70%;
  padding: 5px;
  border-radius: 5px;
  border-color: #ccc;
}
</style>
